import React from 'react';
import { Flex, FlexProps, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { SkeletonColors } from '../../../constants';

interface ProfileLoadingPlaceholderProps {
	wrapperProps?: FlexProps;
}

export const ProfileLoadingPlaceholder = ({
	wrapperProps,
}: ProfileLoadingPlaceholderProps) => {
	//? uncomment if the sidebar state is going to be saved to show only avatar placeholder on loading
	// if (collapsed) {
	// 	return (
	// 		<Center>
	// 			<SkeletonCircle boxSize="40px" {...SkeletonColors} />
	// 		</Center>
	// 	);
	// }
	return (
		<Flex gap="15px" align="center" {...wrapperProps}>
			<SkeletonCircle boxSize="40px" {...SkeletonColors} />
			<Flex direction="column" flex={1} gap="2px">
				<Skeleton
					w="full"
					h="19px"
					borderRadius="2px"
					{...SkeletonColors}
				/>
				<Skeleton
					w="full"
					h="19px"
					borderRadius="2px"
					{...SkeletonColors}
				/>
			</Flex>
		</Flex>
	);
};
